<template>
  <div class="container-employee">
    <BasePaySlipEmployeeHead
      :conditions="conditions"
      :conditionIds="conditionIds"
      :disabled="disabled"
    />
    <BasePaySlipEmployeeItem
      v-for="(employee, index) in employeeList"
      v-model="employeeList[index]"
      :key="index"
      :index="index"
      :conditions="conditions"
      :conditionIds="conditionIds"
      :employees="employees"
      :selectedEmployeeIds="selectedEmployeeIds"
      :disabled="disabled"
      :validateForm.sync="employeeList[index].validateForm"
      @remove="handleRemoveItem"
    />
    <div v-if="!disabled">
      <BaseButton @click="onClickAdd">
        {{ $t('apps.payroll.button.addemployee') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    value: Array,
    conditions: Array,
    conditionIds: Array,
    employees: Array,
    disabled: Boolean,
  },

  data () {
    return {
      employeeList: [],
    }
  },

  computed: {
    selectedEmployeeIds () {
      return this.employeeList.reduce((acc, cur) => {
        if (cur.empId && !acc.includes(cur.empId) && !cur.deleted) {
          acc.push(cur.empId)
        }
        return acc
      }, [])
    },
  },

  watch: {
    'employeeList': {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true,
    },
  },

  created () {
    this.employeeList = cloneDeep(this.value)
    if (this.employeeList.length === 0) {
      this.onClickAdd()
      this.onClickAdd()
    }
  },

  methods: {
    onClickAdd () {
      this.employeeList.push({
        empId: null,
        name: null,
        wageAmount: 0,
        net: 0,
        conditions: [],
        deleted: false,
        conditionsDynamic: true,
        validateForm: null,
      })
    },
    handleRemoveItem (index) {
      this.employeeList[index].deleted = true
      const isDeletedAll = this.employeeList.every((item) => item.deleted)
      if (isDeletedAll) {
        setTimeout(() => {
          this.onClickAdd()
        }, 100)
      }
    },
  },
}
</script>

<style scoped>
.container-employee /deep/ .container-item {
  display: flex;
  margin-bottom: 12px;
}

.container-employee /deep/ .container-item:first-of-type {
  margin-bottom: 2px !important;
}

.container-employee /deep/ .container-item .item {
  flex: 1;
  margin-right: 12px;
}

.container-employee /deep/ .container-item .wages {
  max-width: 140px;
}

.container-employee /deep/ .container-item .insert-column {
  max-width: 140px;
}

.container-employee /deep/ .container-item .net {
  max-width: 140px;
  margin-right: 0;
}

.container-employee /deep/ .container-item .delete {
  max-width: 50px;
  font-size: 18px;
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BasePaySlipEmployee.vue